<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <path fill="#07F" fill-rule="evenodd"
        d="M17 14.33l-5.645 5.645a1.38 1.38 0 1 1-1.951-1.95l6.62-6.621a1.38 1.38 0 0 1 1.951 0l6.621 6.62a1.38 1.38 0 1 1-1.95 1.951L17 14.33z"/>
</svg>
